export const LogoLoader = () => {
    return <img src='/assets/images/TheGuarantors_Symbol.svg' alt="The Guarantors" />
}

export default LogoLoader;
